import React from "react";
import { Card, Dropdown, Menu, Button, Tooltip } from "antd";
import {
  EllipsisOutlined,
  CalendarOutlined,
  UserOutlined,
  CommentOutlined,
  EyeOutlined,
} from "@ant-design/icons";

const statusColors = {
  "To Do": "#1890ff",
  "In Progress": "#52c41a",
  Done: "#13c2c2",
  "On Hold": "#faad14",
  Archived: "#ff4d4f",
};

function TaskCard({
  task,
  onMarkAsDone,
  onMarkInProgress,
  onPutOnHold,
  onAddComment,
  onViewHistory,
  onArchive,
}) {
  const menu = (
    <Menu>
      {task.status !== "In Progress" && task.status !== "Done" && (
        <Menu.Item key="inprogress" onClick={() => onMarkInProgress(task)}>
          Mark as In Progress
        </Menu.Item>
      )}
      {task.status !== "Done" && (
        <Menu.Item key="done" onClick={() => onMarkAsDone(task)}>
          Mark as Done
        </Menu.Item>
      )}
      {task.status !== "Archived" && (
        <Menu.Item key="archive" onClick={() => onArchive(task)}>
          Archive Task
        </Menu.Item>
      )}
      <Menu.Divider />
      {task.status !== "On Hold" && task.status !== "Done" && (
        <Menu.Item key="onhold" onClick={() => onPutOnHold(task)}>
          On Hold / Pending
        </Menu.Item>
      )}
      <Menu.Item key="comment" onClick={() => onAddComment(task)}>
        Add Comment
      </Menu.Item>
    </Menu>
  );

  return (
    <Card
      key={task.key}
      style={{
        marginBottom: 12,
        borderRadius: 10,
        boxShadow: "0 1px 5px rgba(162, 27, 27, 0.08)",
        position: "relative",
        borderLeft: `6px solid ${statusColors[task.status] || "#ccc"}`,
        borderTop: "1px solid #e0e0e0",
        borderRight: "1px solid #e0e0e0",
        borderBottom: "1px solid #e0e0e0",
        padding: 16,
      }}
      size="small"
      variant="borderless"
    >
      <div style={{ position: "absolute", top: 8, right: 8, display: "flex", gap: 8 }}>
        <Button
          type="text"
          icon={<EyeOutlined />}
          onClick={() => onViewHistory(task)}
          title="View History"
        />
        <Dropdown overlay={menu} trigger={["click"]} placement="bottomRight">
          <Button type="text" icon={<EllipsisOutlined />} />
        </Dropdown>
      </div>

      <p
        style={{
          marginBottom: 8,
          fontSize: 16,
          fontWeight: "600",
          color: "#222",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
        title={task.task}
      >
        {task.task}
      </p>

      <p
        style={{
          marginTop: 0,
          marginBottom: 12,
          fontSize: 14,
          color: "#555",
          whiteSpace: "normal",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
        title={task.description}
      >
        {task.description}
      </p>

      <div
        style={{
          fontSize: 13.5,
          color: "#444",
          display: "flex",
          gap: 16,
          flexWrap: "wrap",
          marginBottom: task.comment ? 6 : 0,
        }}
      >
        <Tooltip title={`Due Date: ${task.dueDate}`}>
          <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
            <CalendarOutlined style={{ color: "#888", fontSize: 14 }} />
            <span>{task.dueDate}</span>
          </div>
        </Tooltip>

        <Tooltip title={`Employees: ${task.employees.join(", ")}`}>
          <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
            <UserOutlined style={{ color: "#888", fontSize: 14 }} />
            <span>{task.employees.join(", ")}</span>
          </div> 
        </Tooltip>
      </div>

      {task.comment && (
        <div
          style={{
            fontSize: 13,
            color: "#666",
            display: "flex",
            alignItems: "center",
            gap: 6,
          }}
        >
          <CommentOutlined style={{ fontSize: 14 }} />
          <span
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
            title={task.comment}
          >
            {task.comment}
          </span>
        </div>
      )}
    </Card>
  );
}

export default TaskCard;
